{
  "authors": {
    "from": "av {{author}}",
    "byline": "Byline {{author}}",
    "lastDoneMarked": "Senast klarmarkerad {{created}} av {{author}}",
    "doneBy": "Klar av {{author}}",
    "createdBy": "Skapad av {{author}}",
    "approvedBy": "Godkänd av {{author}}",
    "statusTimeBy": "{{status}} {{created}} av {{author}}"
  },
  "assignmentTypes": {
    "text": "Artikel",
    "flash": "Flash",
    "editorial-info": "Till red",
    "graphic": "Grafik",
    "picture": "Bild",
    "video": "Video",
    "picture/video": "Bild/Video",
    "live-streaming": "Live",
    "timeless": "Tidlös"
  },
  "toolbar": {
    "clearFilters": "Rensa",
    "savePersonalFilter": "Spara personligt filter",
    "personalFilter": "Personligt filter",
    "toggleUserFilter": "Växla användarfilter",
    "toggleLabel": "Växla {{label}}",
    "navigateToday": "Gå till idag",
    "freeText": "Fritext",
    "freeTextSearch": "Fritextsökning",
    "altSearch": "Sök alternativ"
  },
  "status_menu": {
    "cause": "Anledning",
    "pickCause": "Välj anledning...",
    "planningDate": "Datum",
    "setTime": "Ange tid",
    "asSavePlaceholder": "Publicera ny information",
    "embargoMinTime": "Embargo: kan inte schemaläggas före {{time}}",
    "timeInPast": "Vald tid har passerat",
    "planningDateInPast": "Planeringens datum har passerat. Flytta uppdraget till en planering för den dag du vill publicera.",
    "beforeEmbargo": "Tiden är före embargo",
    "timezoneMismatch": "Din enhet är inställd på en annan tidszon än den som används i systemet. Ange tid för publicering i systemets tidszon (skillnad {{offset}}).",
    "publishesInDefaultTz": "Publiceras {{time}} (systemets tidszon)",
    "publishesInUserTz": "= {{time}} i din tidszon ({{tz}})",
    "schedulingRequiresPlanning": "Schemaläggning är inte tillgänglig eftersom dokumentet saknar en kopplad planering.",
    "titleFallback": "Rubrik saknas i artikeln! Uppdragets rubrik \"{{title}}\" kommer att användas.",
    "titleMissingBoth": "Rubrik saknas i både artikeln och uppdraget!",
    "causes": {
      "development_short": "UV",
      "development_long": "Utveckling",
      "fix_short": "KORR",
      "fix_long": "Korrigering",
      "correction_short": "RÄ",
      "correction_long": "Rättelse",
      "retransmission_short": "OMS",
      "retransmission_long": "Omsändning"
    }
  },
  "copy": {
    "copiedTo": "Kopierad till",
    "copiedFrom": "Kopierad från",
    "copyType": "Kopiera {{type}}",
    "copyPrompt": "Vill du kopiera \"{{title}}\" till {{start}}?",
    "copySuccess": "\"{{title}}\" har kopierats till {{start}}",
    "copyEventPrompt": "Vill du kopiera händelsen till {{datesFormatted}}?",
    "copyEventSuccess": "Händelsen \"{{title}}\" har kopierats till {{datesFormatted}}"
  },
  "operations": {
    "authorCreateSuccess": "Författardokument är skapat",
    "authorUpdateSuccess": "Författardokument har uppdaterats",
    "authorSaveSuccess": "Författardokument har sparats",
    "savedFilter": "Ditt filter har sparats",
    "documentSaveSuccess": "Dokument sparat"
  },
  "prompts": {
    "publishBeforeClose": "Vill du publicera ändringarna innan du stänger?",
    "savedButNotPublished": "Ändringarna är sparade men inte publicerade."
  },
  "editorialInfo": {
    "noteText": "Obs! Detta meddelande är inte avsett för publicering."
  },
  "init": {
    "failedTitle": "Kunde inte initiera",
    "retryButton": "Försök igen"
  }
}
